import { render } from "./DeclinedClearanceCertificates.vue?vue&type=template&id=08d49421&scoped=true"
import script from "./DeclinedClearanceCertificates.vue?vue&type=script&lang=js"
export * from "./DeclinedClearanceCertificates.vue?vue&type=script&lang=js"

import "./DeclinedClearanceCertificates.vue?vue&type=style&index=0&id=08d49421&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d49421"]])

export default __exports__